import { render } from "./StateInfo.vue?vue&type=template&id=3bae4d72&scoped=true"
import script from "./StateInfo.vue?vue&type=script&lang=js"
export * from "./StateInfo.vue?vue&type=script&lang=js"

import "./StateInfo.vue?vue&type=style&index=0&id=3bae4d72&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bae4d72"]])

export default __exports__